import { useCallback } from 'react';
import addPathPrefix from 'utils/addPathPrefix';
import { useTemplateContext } from './TemplateContext';

const useTemplatePath = () => {
    const { template, form } = useTemplateContext();

    return useCallback(
        (path: string) => (template && form ? addPathPrefix(`${form}.defaults`, path) : path),
        [template, form]
    );
};

export default useTemplatePath;
